export enum EAccessSystem {
  WithoutAccessSystem = 1,
  WithAccessSystem = 2,
}
